import { render } from "./vgpButton.vue?vue&type=template&id=8ea900ea&scoped=true"
import script from "./vgpButton.vue?vue&type=script&lang=js"
export * from "./vgpButton.vue?vue&type=script&lang=js"

import "./globalButton.less?vue&type=style&index=0&id=8ea900ea&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ea900ea"]])

export default __exports__